import { GetApiData } from "utils/http-client";

export const getAllPackages = async (page = 1, limit = 10) => {
    return await GetApiData(`/package?page=${page}&limit=${limit}`, "GET", null, true);
};

export const createPackage = async (data) => {
    return await GetApiData(`/package`, "POST", data, true);
};

export const editPackage = async (id, data) => {
    return await GetApiData(`/package/${id}`, "PUT", data, true);
};

export const deletePackage = async (id) => {
    return await GetApiData(`/package/${id}`, "DELETE", null, true);
};
